// extracted by mini-css-extract-plugin
module.exports = {"root":"uyjP-g","iconButton":"S-0dM1","displayMobileIcon":"RGO2IA","narrow":"QfZou8","text":"nwa3XQ"};